
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import Index from "./pages/Index";
import Survey from "./pages/Survey";
import SurveyComplete from "./pages/SurveyComplete";
import Admin from "./pages/Admin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminRequests from "./pages/AdminRequests";
import GroupLeaderRegistration from "./pages/GroupLeaderRegistration";
import GroupLeaderSurvey from "./pages/GroupLeaderSurvey";
import ConfirmInvitation from "./pages/ConfirmInvitation";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/survey/:token" element={<Survey />} />
              <Route path="/survey-complete" element={<SurveyComplete />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/requests" element={<AdminRequests />} />
              <Route path="/admin/survey/:meetingNumber" element={<GroupLeaderSurvey />} />
              <Route path="/admin/register" element={<GroupLeaderRegistration />} />
              <Route path="/register" element={<GroupLeaderRegistration />} />
              <Route path="/group-leader-survey" element={<GroupLeaderSurvey />} />
              <Route path="/confirm-invitation" element={<ConfirmInvitation />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/reset-password/r/:payload" element={<ResetPassword />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
